import React from 'react';
import { Button } from 'antd';
import { injectIntl } from 'react-intl';
import { useHistory } from 'react-router-dom';

function Error({ intl, error }:any) {
  const history = useHistory();

  return (
    <div className="patient patient-error flexRow centerHorizontal centerVertical">
      <div className="flexCol centerHorizontal">
        <img className="errorImg" src="/img/error/Error.png" alt="error" />
        <h1>{intl.formatMessage({ id: 'pacientes.error.error_produced' })}</h1>
        <div className="errorMessage">{error}</div>
        <Button
          type="primary"
          onClick={() => history.go(0)}
        >
          {intl.formatMessage({ id: 'pacientes.error.try_again' })}
        </Button>
      </div>
    </div>
  );
}

export default injectIntl(Error);
